import cn from "classnames";
import { REPORT_TYPES } from "helpers/reports";
import { ymEvent } from "helpers/system";
import moment from "moment";
import React, { useState } from "react";
import AccountsReceivableFilters from "../show/filters/accountsReceivableFilters";
import PeriodFilter from "../show/filters/period";
import ToggleFilter from "../show/filters/toggleFilter";

export default function SettlementFilters({
    state,
    setFilter,
    setDateValue,
    getItem,
    onRefresh,
    forceUpdateReport,
    organizationTimezone,
}) {
    const [filtersOpened, setFiltersOpened] = useState(false);
    const expandCname = cn("b-filter__collapse-btn", {
        "b-filter__collapse-btn--top": filtersOpened,
        "b-filter__collapse-btn--bottom": !filtersOpened,
    });
    const toggleProps = { setFilter, getItem, forceUpdateReport };

    const isValidDateValue = (value) => Boolean(value) && moment(value).isValid();
    const hasValidPeriod = isValidDateValue(state.startDate) && isValidDateValue(state.endDate);
    const refreshDisabled = !hasValidPeriod;

    const defaultBtn = () => (
        <div className={cn("mb-md-0", { "report__filters--refresh": !filtersOpened })}>
            <button
                className={cn("btn btn-sm btn-brand", { disabled: refreshDisabled })}
                type="button"
                disabled={refreshDisabled}
                onClick={() => {
                    if (!refreshDisabled) {
                        onRefresh();
                    }
                }}
            >
                Обновить
            </button>
        </div>
    );

    return (
        <div className="planning-table__header">
            <div className="d-flex justify-content-between w-100">
                <div className="report__filters-wrapper w-100">
                    <div className="w-100 report-filters report__filters--mobile">
                        <div className="b-filter__head" onClick={() => setFiltersOpened(!filtersOpened)}>
                            <div className="b-filter__head--left">
                                {!filtersOpened && <div className="b-filter__filter-icon" />}
                                <div
                                    className={cn("b-filter__search-text", {
                                        "b-filter__search-text--dark": filtersOpened,
                                    })}
                                >
                                    Фильтры
                                </div>
                            </div>
                            <div className="b-filter__head--right">
                                <div className={expandCname} />
                            </div>
                        </div>
                    </div>
                    <div className={cn("report__filters-body", { "report__filters-body--show": filtersOpened })}>
                        <div className="report__filters--left">
                            <div className="d-flex flex-nowrap">
                                <PeriodFilter
                                    id={REPORT_TYPES.AccountsReceivableReport}
                                    values={state}
                                    setDateValue={setDateValue}
                                    organizationTimezone={organizationTimezone}
                                />
                            </div>
                            {defaultBtn()}
                        </div>
                        <div className="report__filters--right ml-auto justify-content-end align-items-center text-right">
                            {!state.demoData && <AccountsReceivableFilters values={state} {...toggleProps} />}
                            <br />
                            <ToggleFilter
                                name="groupByDates"
                                label="Группировать по датам оплаты"
                                value={state.groupByDates}
                                testId="toggle-group-by-date"
                                {...toggleProps}
                                onBeforeChange={(value) => {
                                    if (!value) {
                                        ymEvent("GroupByDebtPaymentDates");
                                    }
                                }}
                            />
                            <ToggleFilter
                                name="groupByCounterparties"
                                label="Группировать по контрагентам"
                                value={state.groupByCounterparties}
                                testId="toggle-group-by-counterparties"
                                {...toggleProps}
                            />
                            <ToggleFilter
                                name="onlyOverdue"
                                label="Только просроченные"
                                value={state.onlyOverdue}
                                {...toggleProps}
                                tooltipPlacement="bottom"
                                tooltip={
                                    <>
                                        Неоплаченные основания с просроченной
                                        <br /> плановой датой и положительным остатком
                                    </>
                                }
                            />
                        </div>
                    </div>
                    <div className={cn("report__filters-footer", { "report__filters-footer--show": filtersOpened })}>
                        {defaultBtn()}
                    </div>
                </div>
            </div>
        </div>
    );
}
